import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Button,
  Container,
  DataGridButton,
  Title,
  UserDeleteOptionsGreen,
  UserDeleteOptionsRed,
} from "./styles";
import { Alert, AlertColor, Avatar, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { UserPermissions } from "../../App";

interface Props {
  userPermissions: UserPermissions;
}
const Softwares: React.FC<Props> = ({ userPermissions }) => {
  const navigate = useNavigate();

  const [packageID, setPackageID] = useState("");

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 350,
      renderCell: (params: any) => (
        <>
          <Avatar
            src={params.row.logo}
            sx={{ height: "2rem", width: "2rem", marginRight: "1rem" }}
          />{" "}
          {params.value}
        </>
      ),
    },
    {
      field: "id",
      headerName: "Package ID",
      width: 340,
    },
    {
      field: "owners",
      headerName: "Owners",
      width: 250,
    },
    {
      field: "action",
      headerName: "Action",
      width: 250,
      renderCell: (params: any) => (
        <span style={{}}>
          <DataGridButton
            onClick={() => {
              navigate(
                process.env.PUBLIC_URL + "/Softwares/View/" + params.row.id
              );
            }}
          >
            View
          </DataGridButton>
          {packageID === params.row.id ? (
            <>
              Delete?{" "}
              <UserDeleteOptionsRed
                onClick={() => {
                  deleteSoftware(params.row.id);
                  setPackageID("");
                }}
              >
                Yes
              </UserDeleteOptionsRed>{" "}
              <UserDeleteOptionsGreen
                onClick={() => {
                  setPackageID("");
                }}
              >
                No
              </UserDeleteOptionsGreen>
            </>
          ) : (
            params.row.canDelete && (
              <DataGridButton
                style={{ color: "#DB3A34", border: "2px solid #DB3A34" }}
                onClick={() => {
                  setPackageID(params.row.id);
                }}
              >
                Delete
              </DataGridButton>
            )
          )}
        </span>
      ),
    },
  ];

  const [tableData, setTableData] = useState([
    /**{
            id: "com.acme_inc.rehabgame",
            name: "Serious Game 1 - Rehabilitation Tool",
            owners: ["Acme Inc"],
            canDelete: false
        }**/
  ]);

  const deleteSoftware = (id: string) => {
    console.log("Delete: ", id);
    fetch("/api/v1/software/remove", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data?.success === true) {
          getSoftwares();
          setStatusMsg("Software deleted!");
          setStatusSeverity("success");
          setShowStatus(true);
        } else {
          getSoftwares();
          setStatusMsg(`Cannot delete software: ${data.reason}`);
          setStatusSeverity("error");
          setShowStatus(true);
        }
      }).catch((err) => {
        console.log("Cannot delete software:", err);
        getSoftwares();
        setStatusMsg(`Cannot delete software: Unkown Error`);
        setStatusSeverity("error");
        setShowStatus(true);
      })
  };

  const getSoftwares = () => {
    fetch("/api/v1/software/list", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        /**
             *  {
                    id: "com.acme_inc.rehabgame2",
                    name: "Serious Game 1 - Rehabilitation Tool",
                    owners: ["UserX", "ClinicalX", "HospitalY"],
                    canDelete: true
                },
             */
        if (data.success === true) {
          setTableData(
            data.softwares.map((val: any) => {
              return {
                id: val.id,
                name: val.name,
                logo: val.logo,
                owners: val.owners.map((ownVal: any) => ownVal.name),
                canDelete: val.canDelete,
              };
            })
          );
          setTableLoading(false);
        }
      }).catch((err) => console.log("Error while fetching software list:", err));
  };

  const [tableLoading, setTableLoading] = useState(false);
  useEffect(() => {
    setTableLoading(true);
    getSoftwares();

    const interval = setInterval(() => {
      getSoftwares();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const [showStatus, setShowStatus] = React.useState(false);
  const [statusMsg, setStatusMsg] = React.useState("");
  const [statusSeverity, setStatusSeverity] =
    React.useState<AlertColor>("error");
  const handleCloseStatus = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setShowStatus(false);
  };

  return (
    <Container>
      <Title>
        Softwares{" "}
        <Button
          onClick={() => {
            navigate(process.env.PUBLIC_URL + "/Softwares/Create");
          }}
        >
          Add new software
        </Button>
      </Title>

      <div style={{ height: 500, width: "100%", paddingTop: "1rem" }}>
        <DataGrid
          style={{ fontWeight: 900, color: "rgba(55, 73, 87, 0.7)" }}
          rows={tableData}
          columns={columns}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          components={{ Toolbar: GridToolbar }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          loading={tableLoading}
        />
      </div>

      <Snackbar
        open={showStatus}
        autoHideDuration={2000}
        onClose={handleCloseStatus}
      >
        <Alert
          onClose={handleCloseStatus}
          severity={statusSeverity}
          sx={{ width: "100%" }}
        >
          {statusMsg}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Softwares;
